var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "394.000000pt",
    height: "271.000000pt",
    viewBox: "0 0 394.000000 271.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,271.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119 2504 c-60 -18 -140 -90 -170 -151 -17 -37 -23 -69 -25 -140 -2 -51 0 -93 5 -93 4 0 20 13 36 30 15 16 49 39 74 52 l46 23 975 2 c844 3 984 1 1039 -12 194 -46 362 -208 422 -404 26 -88 30 -216 10 -301 -50 -206 -210 -372 -421 -437 -50 -16 -162 -18 -1184 -20 l-1128 -4 7 -47 c15 -99 86 -186 182 -222 55 -20 64 -21 1107 -18 l1051 3 75 23 c323 99 548 335 627 658 24 102 22 305 -6 409 -79 303 -314 544 -621 637 l-75 23 -990 2 c-839 2 -997 0 -1036 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 1981 c3 -28 13 -64 22 -81 25 -48 84 -109 129 -133 l41 -22 855 -3 c470 -1 1151 -3 1513 -5 l657 -2 0 21 c0 94 -91 218 -186 253 -54 21 -67 21 -1546 21 l-1491 0 6 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 1508 c0 -43 49 -146 86 -180 16 -15 54 -38 84 -52 l55 -26 1185 0 1185 0 51 24 c92 43 154 124 170 224 l7 42 -1412 0 -1411 0 0 -32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/SiteIcon.74e106d5605e0055815caa18abce1acd.svg";
export { ForwardRef as ReactComponent };